import { render, staticRenderFns } from "./RecommendedProductsBlock.vue?vue&type=template&id=4d63ed34&"
import script from "./RecommendedProductsBlock.vue?vue&type=script&lang=js&"
export * from "./RecommendedProductsBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports